module.exports = __webpack_public_path__ + "static/media/Group 2topbar.84122c25.svg";